import styled from '@emotion/styled';

import Button from 'components/field/Button';
import Form from 'components/form/Form';
import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	@media (min-width: 1367px) {
		padding-right: 0 !important;
	}
`;

export const StyledCardWithAvatar = styled(Card)`
	display: flex;
	flex-direction: column;
	/* padding: 2rem 2.5rem; */
	padding: 2.5rem;
	gap: 2rem;
	width: 100%;
	max-height: unset;
	overflow: visible;
	@media ${Breakpoints.mobile} {
		flex-direction: column;
		padding: 1rem;
		gap: 1rem;
	}
`;

export const StyledCard = styled(Card)`
	display: flex;
	flex-direction: column;
	padding: 2rem;
	overflow: unset;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		padding: 2rem 1rem;
	}
`;

export const StyledForm = styled(Form)`
	gap: 3rem;
	display: flex;
	flex-direction: column;
	max-height: unset;
	padding-bottom: 3rem !important;
	flex-wrap: nowrap;
	@media ${Breakpoints.mobile} {
		padding: 0 !important;
		margin-bottom: 10rem;
	}
`;

export const StyledSecurityForm = styled(Form)`
	gap: 3rem;
	display: flex;
	flex-direction: column;
	max-height: unset;
	padding-bottom: 3rem !important;
	flex-wrap: nowrap;

	@media ${Breakpoints.mobile} {
		padding: 0 !important;
		margin-bottom: 2rem;
	}
`;

export const NotificationSettingsContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 2rem;
	padding-bottom: 2rem;
`;

export const SecurityRequirementsWrapper = styled.div`
	display: flex;
`;

export const SecurityRequirementsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	width: 100%;
	max-width: max-content;
	gap: 2rem;
	padding: 1rem;

	@media ${Breakpoints.mobile} {
		padding: 0.5rem;
		gap: 0.5rem;
		grid-template-columns: repeat(1, 1fr);
	}
`;

export const SecurityRequirementsItem = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
	gap: 1rem;

	@media ${Breakpoints.mobile} {
		gap: 0.5rem;
	}
`;

export const FlexBox = styled.div`
	display: ${({ $grid }) => ($grid ? 'grid' : 'flex')};
	gap: 1rem;
	width: 100%;
	${({ $justifyContent }) => $justifyContent && `justify-content: ${$justifyContent};`}
	${({ $alignItems }) => $alignItems && `align-items: ${$alignItems};`}
	${({ $flexDirection }) => $flexDirection && `flex-direction: ${$flexDirection};`}
	${({ $gap }) => $gap && `gap: ${$gap};`}
`;

export const FormContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: flex-start;
	gap: 1rem;
	width: 100%;
	justify-content: space-between;
	.form-item {
		margin: 0 !important;
		padding-right: 0;
		padding-left: 0;
	}
	& > div {
		width: 49% !important;
	}
	@media ${Breakpoints.mobileLandscape} {
		flex-direction: column;
		gap: 0.5rem;
		& > div {
			width: 100% !important;
		}
	}
`;

export const PreferencesContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	gap: 2rem;
	@media ${Breakpoints.mobile} {
		flex-direction: column;
		align-items: flex-end;
	}
`;

export const PreferenceActionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
`;

export const UserAvatarContainer = styled(FlexBox)`
	justify-content: space-between;
	@media ${Breakpoints.mobile} {
		flex-direction: column;
		padding-bottom: 1rem;
	}
`;

export const TwoFactorCard = styled(Card)`
	display: flex;
	flex-direction: column;
	padding: 2.5rem;
	gap: 1rem;
	overflow: visible;

	@media ${Breakpoints.tablet} {
		margin-bottom: 3rem;
	}

	@media ${Breakpoints.mobile} {
		padding: 2rem 1.5rem;
		gap: 2rem;
		margin-bottom: 10rem;
	}
`;

export const TwoFactorSettingsSection = styled.div`
	display: flex;
	flex-direction: row;

	> .button {
		flex: 1 0 auto;
		margin: auto 0;
	}
`;

export const TwoFactorCardContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
`;

export const TwoFactorCardTitle = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
`;

export const TwoFactorDisableButton = styled(Button)`
	&.outline {
		background: var(--alwaysWhiteColor);
		border-color: var(--red);
		color: var(--red);

		:not(.disabled):hover {
			background: var(--red-hover);
			color: var(--white);

			.button-text,
			.button-icon {
				color: var(--alwaysWhiteColor);
			}
		}

		.button-text,
		.button-icon {
			color: var(--red);
		}
	}
`;
export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 1rem;
	@media ${Breakpoints.tablet} {
		display: none;
	}
	body[dir='rtl'] & {
		.icon {
			transform: rotate(180deg);
		}
	}
`;

export const ModulesContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	gap: 2rem;
	@media ${Breakpoints.mobile} {
		flex-direction: column;
		align-items: flex-start;
	}
	padding: var(--padding-3) 0;
`;

export const SectionTitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	padding-bottom: 3rem;
`;

export const ConfigurationStyledCard = styled(Card)`
	display: flex;
	flex-direction: column;
	padding: 2.8rem;
	overflow: unset;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		padding: 2rem 1rem;
	}
`;
